import React, { useState, useEffect } from "react";
import { usePost } from "../../customHooks/usePost";
import { useGet } from "../../customHooks/useGet";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaPlusCircle, FaTimesCircle } from "react-icons/fa";

function SchoolForm({ setShowForm, updateSchools }) {
  const [newSchool, setNewSchool] = useState({
    name: "",
    province: "",
    city: "",
    address: "",
    phone: "",
    mail: "",
    status: true,
    user: "",
  });

  const { data: provincesData, loading: provincesLoading, error: provincesError } = useGet(
    "https://ectech-software.com.ar/api/core/provinces?page=0&size=5000"
  );

  const [citiesUrl, setCitiesUrl] = useState(null);
  const { data: citiesData, loading: citiesLoading, error: citiesError } = useGet(citiesUrl);

  const { data: usersData, loading: usersLoading, error: usersError } = useGet(
    "https://ectech-software.com.ar/api/core/users?page=0&size=5000"
  );

  const { executePost, error: postError, loading: postLoading } = usePost();

  useEffect(() => {
    if (newSchool.province) {
      setCitiesUrl(`https://ectech-software.com.ar/api/core/provinces/${newSchool.province}/cities?page=0&size=5000`);
    } else {
      setCitiesUrl(null);
      setNewSchool((prev) => ({ ...prev, city: "" })); // Resetear ciudad al cambiar provincia
    }
  }, [newSchool.province]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setNewSchool((prevSchool) => ({
      ...prevSchool,
      [name]: value,
      ...(name === "province" ? { city: "" } : {}), // Resetear ciudad al cambiar provincia
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Evitar enviar el formulario si ya hay una solicitud en curso
    if (postLoading) return;

    const selectedCity = citiesData?.content?.find(city => city.id.toString() === newSchool.city);
    const selectedUser = usersData?.content?.find(user => user.id === parseInt(newSchool.user, 10));

    if (!selectedCity || !selectedUser) {
      alert("Por favor, selecciona una ciudad y un usuario válidos.");
      return;
    }

    const schoolPayload = {
      name: newSchool.name,
      city: { id: selectedCity.id, name: selectedCity.name },
      address: newSchool.address,
      phone: newSchool.phone,
      mail: newSchool.mail,
      status: newSchool.status,
      user: { id: selectedUser.id, name: selectedUser.userData?.name, lastname: selectedUser.userData?.lastname }
    };

    try {
      await executePost('https://ectech-software.com.ar/api/academy/schools', schoolPayload);
      updateSchools(); // Llama a la función para actualizar la lista de escuelas
      setShowForm(false);
    } catch (err) {
      console.error('Error al crear la escuela:', err);
      alert("Hubo un problema al crear la escuela. Intenta nuevamente."); // Muestra un error al usuario
    }
  };

  return (
    <div className="container mt-4">
      <div className="card shadow-lg p-4 w-100" style={{ maxWidth: "600px", margin: "auto" }}>
        <div className="card-header bg-primary text-white text-center">
          <h5 className="mb-0">Nueva Escuela</h5>
        </div>
        <div className="card-body">
          <form onSubmit={handleSubmit}>
            <div className="form-floating mb-3">
              <input type="text" id="name" name="name" value={newSchool.name} onChange={handleChange} className="form-control" required />
              <label htmlFor="name">Nombre de la Escuela</label>
            </div>

            <div className="form-floating mb-3">
              <input type="text" id="address" name="address" value={newSchool.address} onChange={handleChange} className="form-control" required />
              <label htmlFor="address">Dirección</label>
            </div>

            <div className="form-floating mb-3">
              <input type="text" id="phone" name="phone" value={newSchool.phone} onChange={handleChange} className="form-control" required />
              <label htmlFor="phone">Teléfono</label>
            </div>

            <div className="form-floating mb-3">
              <input type="email" id="mail" name="mail" value={newSchool.mail} onChange={handleChange} className="form-control" required />
              <label htmlFor="mail">Correo Electrónico</label>
            </div>

            <div className="mb-3">
              <label className="form-label">Provincia:</label>
              {provincesLoading ? (
                <p>Cargando provincias...</p>
              ) : provincesError ? (
                <p className="text-danger">{provincesError.message}</p>
              ) : (
                <select name="province" value={newSchool.province} onChange={handleChange} className="form-select" required>
                  <option value="">Seleccionar provincia</option>
                  {provincesData?.content?.map((province) => (
                    <option key={province.id} value={province.id}>{province.name}</option>
                  ))}
                </select>
              )}
            </div>

            <div className="mb-3">
              <label className="form-label">Ciudad:</label>
              {citiesLoading ? (
                <p>Cargando ciudades...</p>
              ) : citiesError ? (
                <p className="text-danger">{citiesError.message}</p>
              ) : (
                <select name="city" value={newSchool.city} onChange={handleChange} className="form-select" required>
                  <option value="">Seleccionar ciudad</option>
                  {citiesData?.content?.map((city) => (
                    <option key={city.id} value={city.id}>{city.name}</option>
                  ))}
                </select>
              )}
            </div>

            <div className="mb-3">
              <label className="form-label">Usuario:</label>
              {usersLoading ? (
                <p>Cargando usuarios...</p>
              ) : usersError ? (
                <p className="text-danger">{usersError.message}</p>
              ) : (
                <select name="user" value={newSchool.user} onChange={handleChange} className="form-select" required>
                  <option value="">Seleccionar usuario</option>
                  {usersData?.content?.map((user) => (
                    <option key={user.id} value={user.id}>
                      {user.userData?.name} {user.userData?.lastname}
                    </option>
                  ))}
                </select>
              )}
            </div>

            <div className="d-flex gap-2">
              <button type="submit" disabled={postLoading} className="btn btn-primary w-50">
                {postLoading ? "Creando Escuela..." : "Crear Escuela"} <FaPlusCircle className="ms-2" />
              </button>
              <button type="button" className="btn btn-outline-secondary w-50" onClick={() => setShowForm(false)}>
                Cancelar <FaTimesCircle className="ms-2" />
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default SchoolForm;
